import { useMutation, useQueryClient } from '@tanstack/react-query'
import { requestServices } from '../requestServices'
import type { CreateRequestPayload } from '../requestTypes'

/**
 * Hook for creating a new payment request
 * Based on React Native useCreateInteractRequest
 */
export const useCreateRequest = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreateRequestPayload) =>
      requestServices.createRequest(payload),
    onSuccess: () => {
      // Invalidate requests cache to refresh the list (same as React Native)
      queryClient.invalidateQueries({
        queryKey: ['payment-requests/history'],
      })
      // Also invalidate transactions, as a request may affect overall activity
      queryClient.invalidateQueries({
        queryKey: ['transactions'],
      })
      // Invalidate wallet cache to update balance
      queryClient.invalidateQueries({
        queryKey: ['wallet'],
      })
    },
  })
}
